import { defaultRegion } from 'boot/firebase';

export default () => {
  return {
    region: defaultRegion,
  };
};
